import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { ContactFormFullwidth } from 'components';
import { enableAnimations } from 'config/helpers';
import {
  Banner,
  Problem,
  Solution,
  Teams,
  Process,
  ClientQuotes,
  HowWeBuild,
  LearnMore,
  OtherServices,
} from './subcomponents';
import './DevelopmentTeams.scss';

class DevelopmentTeams extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles } = this.props;

    return (
      <div className={'single-page single-page--hero development-teams'}>
        <Banner />
        <Problem />
        <Solution />
        <Teams />
        <LazyLoad offset={200}>
          <Process />
        </LazyLoad>
        <LazyLoad offset={200}>
          <ClientQuotes />
        </LazyLoad>
        <HowWeBuild />
        <ContactFormFullwidth
          name={'development-teams-contact-form'}
          pardotLink={'https://go.boldare.com/l/688533/2019-02-28/x81'}
        />
        <LearnMore allArticles={allArticles} />
        <OtherServices />
      </div>
    );
  }
}

export default DevelopmentTeams;
